import React from 'react';
import PropTypes from 'prop-types';
import {connect, useDispatch} from "react-redux";
import {hideModal} from "./reducer/ModalActions";
import apiPlatform from "../../apiPlatform";
import {toast} from "react-toastify";
import ClientMailForm from "../ClientMail/ClientMailForm";
import AppModalForm from "../../componentsReusable/AppModalForm";

const EmailModalContainer = props => {
  const dispatch = useDispatch();

  if(!props.modal.isOpen){
    return null
  }

  return <AppModalForm
    modalOpen
    modalButtonAccept={<React.Fragment>
      <i className="fas fa-send" /><span>Wyślij e-mail</span>
    </React.Fragment>}
    formProps={{
      data: props.modal.data,
      apiFn: apiPlatform.clientMail,
      onCreated: () => {
        toast.success('Wiadomość e-mail została wysłana')
        dispatch(hideModal())
      }
    }}
    modalTitle={'Wiadomość e-mail'}
    form={ClientMailForm}
    handlerOnModalOpen={modalOpen => {
      if(!modalOpen){
        dispatch(hideModal())
      }
    }}
   />
};

EmailModalContainer.propTypes = {

};

function mapStateToProps(state) {
  return {
    modal: state.emailModalContainer
  }
}

export default connect(mapStateToProps)(EmailModalContainer);